/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RowCount } from '../../models/row-count';

export interface GetUserCount$Params {
  searchStr?: string;
  withInactive?: boolean;
}

export function getUserCount(http: HttpClient, rootUrl: string, params?: GetUserCount$Params, context?: HttpContext): Observable<StrictHttpResponse<RowCount>> {
  const rb = new RequestBuilder(rootUrl, getUserCount.PATH, 'get');
  if (params) {
    rb.query('searchStr', params.searchStr, {});
    rb.query('withInactive', params.withInactive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RowCount>;
    })
  );
}

getUserCount.PATH = '/api/users/count';
